import { View, Text } from "@react-pdf/renderer";
import ContractStyles from "../assets/styles/contractStyles";
import ContractListItem from "../constants/listItem";
import RenderClauses from "../constants/renderClauses";
import { formatSerialNumber, numberClauseTree } from "../constants/serialNumbers";

const obligations = [
  {
    title: "Responsibility",
    content:
      "To procure that the Company will agree to accept regulatory responsibility for such activities of the Appointed Representative as may be from time to time expressly authorised under the terms of this Contract.",
  },
  {
    title: "Payment of Fees",
    content:
      "To pay initial advice fees, on-going Appointed Representative charging fees, trail, renewals and commission and any other sums due to the Appointed Representative under the terms of this Contract.",
  },
  {
    title: "Training",
    content: "",
    clauses: [
      {
        content:
          "To provide such training as the Company may reasonably deem necessary for the Appointed Representative and any personnel to carry on the business. Such training and costs to be provided at a place to be determined by the Company.",
      },
      {
        content:
          "This training excludes professional qualifications required by the Appointed Representative to conduct business and Sales Activities.",
      },
    ],
  },
  {
    title: "IT Software",
    content:
      "To provide the Appointed Representative with the required IT Software subject to such terms and conditions which the Company may impose",
  },
  {
    title: "Indemnity",
    content:
      "The Company shall indemnify and keep indemnified the Appointed Representative during the term of this Contract. A £5,000 excess will be payable by the Appointed Representative for any upheld claim.",
  },
];

const TheCompanysObligations = ({ serialNumber = 5 }) => {
  const styles = ContractStyles();

  return (
    <View style={[styles.flexColumn, styles.gap_sm]} break>
      <ContractListItem
        id="the-companys-obligations"
        marker={formatSerialNumber(serialNumber)}
        styles={styles}
        textStyle={[styles.contentSemibold, styles.text_primary]}
      >
        The Company's Obligations
      </ContractListItem>
      <Text style={styles.buttonTextSmall}>
        The Company agrees with the Appointed Representative:
      </Text>

      <View style={[styles.flexColumn, styles.gap_sm]}>
        {numberClauseTree(obligations, serialNumber).map(({ number, title, content, clauses }) => (
          <View
            key={number}
            style={[
              styles.flexColumn,
              styles.gap_xs,
              // { paddingTop: number === "4.5." ? styles.py_lg : styles.py_md },
            ]}
          >
            <ContractListItem
              marker={number}
              markerWidth={24}
              styles={styles}
              textStyle={styles.buttonTextSmall}
            >
              {title}
            </ContractListItem>
            {content && (
              <ContractListItem
                marker=""
                markerWidth={0}
                styles={styles}
                textStyle={styles.buttonTextSmall}
              >
                {content}
              </ContractListItem>
            )}

            <RenderClauses clauses={clauses} styles={styles} number={number} />
          </View>
        ))}
      </View>
    </View>
  );
};

export default TheCompanysObligations;
